import { AnswerData } from '../data';
import styled from '@emotion/styled';
import { StyledContentContainer } from '@selfserve/react-ui';
import { MarketingInfoRadio } from './marketing-info-radio';
import { MarketingInfoCheckbox } from './marketing-info-checkbox';
import { FormikProps } from 'formik';
import { FormData } from '@selfserve/react-feature-marketing-info';
import { useCallback } from 'react';

const StyledAnswersContainer = styled(
  StyledContentContainer,
  {}
)(() => ({
  flexDirection: 'row',
  flexWrap: 'wrap',
  padding: '0',
  justifyContent: 'space-between',
}));

interface Props {
  type: number;
  values: Array<AnswerData>;
  formik: FormikProps<FormData>;
  name: string;
}

export const MarketingAnswersContainer = ({
  type,
  values,
  formik,
  name,
}: Props) => {
  const answerElement = type === 1 ? MarketingInfoRadio : MarketingInfoCheckbox;
  const { setFieldValue } = formik;

  const handleAnswerSelected = useCallback(
    (e: any) => {
      if (type === 1) {
        values.map((a, i) =>
          setFieldValue(name + '[' + i + '].selected', false)
        );
      }

      const answer: AnswerData =
        values.find((i) => i.answerName === e.target.id) || values[0];
      const answerIndex = values.indexOf(answer);

      setFieldValue(name + '[' + answerIndex + '].selected', !answer.selected);
    },
    [values, type, setFieldValue, name]
  );

  return (
    <StyledAnswersContainer>
      {values.map(function (answer) {
        return answerElement({
          handleAnswerSelected: handleAnswerSelected,
          answer: answer,
          odd: values.length % 2 === 1,
        });
      })}
    </StyledAnswersContainer>
  );
};
